export default __webpack_public_path__ + "static/ImpactURW-bb3d67431ffd8fdcb338f83be410e375.woff2";